import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
let QueueUp = class QueueUp extends VuexModule {
    enableAttributesAnalysis = false;
    updataEnableAttributesAnalysis(data) {
        this.enableAttributesAnalysis = data;
    }
};
__decorate([
    Mutation
], QueueUp.prototype, "updataEnableAttributesAnalysis", null);
QueueUp = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/QueueUp' })
], QueueUp);
export const QueueUpModule = getModule(QueueUp);
